<template>
  <div>
    <div class="d-flex justify-space-between">
      <h2 class="page-title-bar">
        <i class="ico ico-overview"></i>{{ $t("Overview") }}
      </h2>
      <!-- <div class="d-flex align-center">
        <span><b>Temperature Unit</b></span>
        <Toggle
          :toggleState="toggleState"
          @valueChanged="valueChanged($event)"
          class="ml-2"
        />
      </div> -->
    </div>
    <v-row class="">
      <v-col sm="12" md="12" lg="12" xl="12" class="py-0 px-0 mt-8">
        <v-row class="ma-0">
          <v-col cols="12" class="d-flex" style="padding: 0px !important;">
            <!-- Device Status  -->
            <v-col cols="6" class="px-0 py-0 d-flex">
              <v-col cols="12" class="pr-3">
                <div class="heading w-100">
                  <h2
                    class="page-title-bar"
                    style="font-weight: normal;font-size: 20px;color: #001E38;"
                  >
                    {{ $t("Device Status") }}
                  </h2>
                </div>
                <v-card
                  class="summary-card d-flex"
                  elevation-2
                  outlined
                  style="cursor: pointer"
                >
                  <div class="col-12 px-0 py-0 d-flex" v-if="!deviceLoading">
                    <div class="col-6 px-0 py-0 row mx-0">
                      <div class="heading w-100">
                        <h3 class="title-head">Connectivity</h3>
                      </div>
                      <div
                        class="w-100 d-flex justify-center"
                        v-if="connectivity.length !== 0"
                      >
                        <GradientDonutChart
                          :chartSeries="connectivity"
                          :chartLabels="connectivityLabels"
                          :chartType="'donut'"
                          :height="250"
                          :chartPlotOptions="donutChartPlotOptions"
                          :colorOption="color"
                          :dataLabelsOption="optionEnable"
                          :chartLegendOption="legendPosBottom"
                          :tooltip="tooltip"
                        ></GradientDonutChart>
                      </div>
                      <div
                        class="w-100 d-flex justify-center"
                        v-if="connectivity.length !== 0"
                      >
                        <div
                          class="mr-3"
                          v-for="(label, idx) in connectivityLabels"
                          :key="idx"
                        >
                          <div class="d-flex align-baseline">
                            <div
                              class="square-icon mr-2"
                              :style="{ backgroundColor: color[idx] }"
                            ></div>
                            <div class="name">{{ label }}</div>
                          </div>
                          <span class="name" style="margin-left: 18px;"
                            ><b>{{ connectivity[idx] }}</b></span
                          >
                        </div>
                      </div>
                      <div class="w-100 mx-5 mt-5" style="height: 100%;" v-else>
                        <v-alert
                          dense
                          color="#697A8A"
                          class="ma-0 d-flex justify-center"
                          style="line-height: 19px; color:#fff"
                        >
                          <v-icon class="mr-1" color="#fff"
                            >mdi-alert-outline</v-icon
                          >
                          {{ $t("No data available") }}
                        </v-alert>
                      </div>
                    </div>
                    <div class="col-6 px-0 py-0 row mx-0">
                      <div class="heading w-100">
                        <h3 class="title-head">Battery</h3>
                      </div>
                      <div
                        class="w-100 d-flex justify-center"
                        v-if="battery.length !== 0"
                      >
                        <GradientDonutChart
                          :chartSeries="battery"
                          :chartLabels="batteryLabels"
                          :chartType="'donut'"
                          :height="250"
                          :chartPlotOptions="donutChartPlotOptions"
                          :colorOption="batteryColor"
                          :dataLabelsOption="optionEnable"
                          :chartLegendOption="legendPosBottom"
                          :tooltip="tooltip"
                        ></GradientDonutChart>
                      </div>
                      <div
                        class="w-100 d-flex justify-center"
                        v-if="battery.length !== 0"
                      >
                        <div
                          class="mr-3"
                          v-for="(label, idx) in batteryLabels"
                          :key="idx"
                        >
                          <div class="d-flex align-baseline">
                            <div
                              class="square-icon mr-2"
                              :style="{ backgroundColor: batteryColor[idx] }"
                            ></div>
                            <div class="name">{{ label }}</div>
                          </div>
                          <span class="name" style="margin-left: 18px;"
                            ><b>{{ battery[idx] }}</b></span
                          >
                        </div>
                      </div>
                      <div class="w-100 mx-5 mt-5" style="height: 100%;" v-else>
                        <v-alert
                          dense
                          color="#697A8A"
                          class="ma-0 d-flex justify-center"
                          style="line-height: 19px; color:#fff"
                        >
                          <v-icon class="mr-1" color="#fff"
                            >mdi-alert-outline</v-icon
                          >
                          {{ $t("No data available") }}
                        </v-alert>
                      </div>
                    </div>
                  </div>
                  <div class="wrapper-loading w-100" v-else>
                    <div class="loader"></div>
                  </div>
                </v-card>
              </v-col>
            </v-col>
            <!-- Alert  -->
            <v-col cols="6" class="px-0 py-0 d-flex">
              <v-col cols="12" class="pr-3">
                <div class="heading w-100">
                  <h2
                    class="page-title-bar"
                    style="font-weight: normal;font-size: 20px;color: #001E38;"
                  >
                    {{ $t("Alert") }}
                  </h2>
                </div>
                <v-card
                  class="summary-card d-flex"
                  elevation-2
                  outlined
                  style="cursor: pointer"
                >
                  <div class="col-12 px-0 py-0 row mx-0">
                    <div class="heading w-100 d-flex mx-3 mt-3">
                      <h3
                        class="title-head pr-2 pt-0"
                        @click="handleAlertBox('Active')"
                        :class="alertActive === 'Active' ? 'active' : ''"
                      >
                        Active
                      </h3>
                      <h3 class="title-head pr-3 pt-0">|</h3>
                      <div class="w-100 d-flex justify-space-between">
                        <h3
                          class="title-head pl-2 pt-0"
                          @click="handleAlertBox('History')"
                          :class="alertActive === 'History' ? 'active' : ''"
                        >
                          History
                        </h3>

                        <v-select
                          label=""
                          :placeholder="$t('Select Duration')"
                          outlined
                          dense
                          hide-details
                          v-model="selectedDuration"
                          :items="durationList"
                          item-text="text"
                          item-value="val"
                          class="form-select col-3 pt-0"
                          v-if="alertActive === 'History'"
                          @change="updateDuration"
                        >
                        </v-select>
                      </div>
                    </div>
                    <div
                      class="w-100 d-flex"
                      v-if="alertActive === 'Active' && !alertLoading"
                      style="height: 100%; margin-top: 6px;"
                    >
                      <div
                        class="col-9 d-flex justify-center"
                        v-if="activeAlert.length !== 0"
                      >
                        <GradientDonutChart
                          :chartSeries="activeAlert"
                          :chartLabels="activeAlertLabels"
                          :chartType="'donut'"
                          :height="250"
                          :chartPlotOptions="donutChartPlotOptions"
                          :colorOption="activeAlertColor"
                          :dataLabelsOption="optionEnable"
                          :chartLegendOption="legendPosBottom"
                          :tooltip="tooltip"
                        ></GradientDonutChart>
                      </div>
                      <div class="col-3" v-if="activeAlert.length !== 0">
                        <div
                          class="mt-3"
                          v-for="(label, idx) in activeAlertLabels"
                          :key="idx"
                          style="cursor:pointer"
                          @click="openAlertDialog(idx, 'donut')"
                        >
                          <div class="d-flex align-baseline">
                            <div
                              class="square-icon mr-2"
                              :style="{
                                backgroundColor: activeAlertColor[idx]
                              }"
                            ></div>
                            <div class="name">{{ label }}</div>
                          </div>
                          <span class="name" style="margin-left: 18px;"
                            ><b>{{ activeAlert[idx] }}</b></span
                          >
                        </div>
                      </div>
                      <div class="w-100 mx-5" v-else>
                        <v-alert
                          dense
                          color="#697A8A"
                          class="ma-0 d-flex justify-center"
                          style="line-height: 19px; color:#fff"
                        >
                          <v-icon class="mr-1" color="#fff"
                            >mdi-alert-outline</v-icon
                          >
                          {{ $t("No data available") }}
                        </v-alert>
                      </div>
                    </div>
                    <div
                      class="w-100"
                      v-else-if="alertActive === 'History' && !alertLoading"
                      :style="categories.length === 0 ? 'height: 100%;' : ''"
                    >
                      <div class="d-flex w-100" v-if="categories.length !== 0">
                        <div class="" style="width: calc(100% - 135px);">
                          <StackChart
                            :data="stackChartData"
                            :categories="categories"
                            :xTitle="''"
                            :noData="noData"
                            :colors="stackColor"
                            :height="320"
                          />
                        </div>
                        <div class="px-0 d-flex align-center">
                          <div style="width: 125px;">
                            <div
                              class="mt-6 ml-3"
                              v-for="(label, idx) in stackChartData"
                              :key="idx"
                              style="cursor:pointer"
                              @click="openAlertDialog(idx, 'stack')"
                            >
                              <div class="d-flex align-baseline">
                                <div
                                  class="square-icon mr-2"
                                  :style="{
                                    backgroundColor: stackColor[idx]
                                  }"
                                ></div>
                                <div class="name">{{ label.name }}</div>
                              </div>
                              <span
                                class="name"
                                style="margin-left: 18px;"
                                v-if="label.data.lenght !== 0"
                                ><b>{{
                                  label.data.reduce(
                                    (accumulator, currentValue) =>
                                      accumulator + currentValue,
                                    0
                                  )
                                }}</b></span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="w-100 px-5 pt-5" style="height: 100%;" v-else>
                        <v-alert
                          dense
                          color="#697A8A"
                          class="ma-0 d-flex justify-center"
                          style="line-height: 19px; color:#fff"
                        >
                          <v-icon class="mr-1" color="#fff"
                            >mdi-alert-outline</v-icon
                          >
                          {{ $t("No data available") }}
                        </v-alert>
                      </div>
                    </div>
                    <div class="wrapper-loading w-100" style="height: 87%;" v-else>
                    <div class="loader"></div>
                  </div>
                  </div>
                </v-card>
              </v-col>
            </v-col>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="pa-0 ma-0">
      <v-col cols="2" class="d-flex align-center pb-0">
        <v-menu v-model="menuOpen" offset-y :close-on-content-click="false" content-class="columnMenu">
          <template v-slot:activator="{ on, attrs }">
            <v-btn text small class="manage-btn btn" v-bind="attrs" v-on="on">
              {{ $t('Manage Columns') }}
              <v-icon right :class="{ rotate: menuOpen }">
                mdi-chevron-down
              </v-icon>
            </v-btn>
          </template>

          <v-card class="column-card">
            <v-card-title class="column-header">
              {{ $t('Select Columns') }}
            </v-card-title>
            <v-divider />
            <v-list dense class="select-all">
              <v-list-item>
                <v-checkbox :input-value="isAllSelected" @change="toggleSelectAll" hide-details />
                <v-list-item-title>
                  {{ $t('Select All') }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
            <v-divider />
            <v-card-text class="column-list">
              <v-list dense>
                <v-list-item v-for="header in tableHeaders.slice(3, tableHeaders.length - 1)" :key="header.value">
                  <v-checkbox v-model="visibleColumns" :value="header.text" hide-details />
                  <v-list-item-title class="column-text">
                    {{ header.text }}
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-card-text>
            <v-divider />
            <v-card-actions class="column-footer">
              <v-btn color="error" style="background: #c57171;color: #ffffff !important;width:80px" text small
                @click="menuOpen = false">
                {{ $t('Cancel') }}
              </v-btn>
              <v-spacer />
              <v-btn color="primary" small style="width:80px" @click="menuOpen = false; saveVisibleColumns()">
                {{ $t('Save') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
      </v-col>
      <v-col cols="1" class="d-flex align-center justify-center pa-0 mt-6">
        <v-divider vertical></v-divider>
      </v-col>
      <v-col cols="9" class="d-flex flex-column px-0">
        <section class="searchArea d-flex flex-wrap">
          <v-text-field :label="$t('Sensor Name')" outlined hide-details dense :placeholder="$t('Input Sensor Name')"
            v-model="searchBy.sensorName" clearable class="form-select col">
          </v-text-field>
          <!--Sensor ID-->
          <v-text-field :label="$t('Sensor ID')" outlined hide-details dense :placeholder="$t('Input Sensor ID')"
            v-model="searchBy.sensorId" clearable class="form-select col ml-3">
          </v-text-field>
          <!-- Sensor Status -->
          <v-select :label="$t('Sensor Status')" :placeholder="$t('Select Sensor Status')" outlined dense hide-details
            v-model="searchBy.sensorStatus" :items="sensorStatusList" item-text="text" item-value="val"
            class="form-select col ml-3" clearable>
          </v-select>
          <v-btn class="btn type-search ml-3" text @click="clickSearch()">{{ $t("Search") }}
          </v-btn>
        </section>
        <section class="searchArea d-flex flex-wrap mt-2">
          <v-select v-model="searchBy.state" :items="sensorStateList" :label="$t('Sensor State')"
            :placeholder="$t('Select Sensor State')" item-value="value" item-text="text" class="form-select col"
            outlined dense hide-details clearable multiple chips @change="onChange(searchBy.state)"
            :class="{ statuslistclass: statelist.length !== 0 }" :menu-props="{ maxHeight: '200' }">
            <template v-slot:selection="{ item, index }" style="display: contents;">
              <span v-if="searchBy.state.length === 0" class="grey--text caption">{{ $t('Select Sensor State') }}</span>
              <span class="item" v-if="index < maxDisplay">{{ $t(item.value) }} </span>
              <span v-if="index === maxDisplay" class="grey--text caption">(+{{ searchBy.state.length - maxDisplay }} {{
                $t('status') }})</span>
            </template>
          </v-select>
          <!--Shelf ID -->
          <v-text-field :label="$t('Location')" outlined hide-details dense :placeholder="$t('Input Location')"
            v-model="searchBy.location" clearable class="form-select col ml-3">
          </v-text-field>
          <v-btn class="btn type-search ml-3" text @click="clearSearch">{{ $t("Clear") }}
          </v-btn>
        </section>
      </v-col>
    </v-row>
    <div class="mt-1">
      <v-data-table
        :headers="filteredTableHeaders"
        :items="tableItems"
        item-key="serialNo"
        :hide-default-footer="true"
        :options.sync="options"
        :server-items-length="tableItems.length"
        :show-select="true"
        v-model="SelectedsensorValue"
        class="tbl-type01 mt-5 row-class"
        fixed-header
        @click:row="openSensorDetails($event)"
        :height="tableItems && tableItems.length > 8 ? '550px' : 'auto'"
      >
        <template slot="loading">
          <div class="wrapper-loading">
            <div class="loader"></div>
          </div>
        </template>
        <template slot="no-data">
          <v-alert dense color="#697A8A" class="ma-0" style="line-height: 19px">
            <v-icon class="mr-1" color="#fff">mdi-alert-outline</v-icon>
            {{ $t("No data available") }}
          </v-alert>
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <div class="d-flex justify-center" v-if="item.status !== '-'">
            <v-tooltip top content-class="tooltip-content">
              <template v-slot:activator="{ on, attrs }">
                <p
                class="circle"
                :style="
                item.status.toLowerCase() === 'offline'.toLowerCase()
                ? 'background-color: #e27070'
                : 'background-color: #9bcde3'
                "
                 v-bind="attrs"
                 v-on="on"
                ></p>
              </template>
              <span class="tooltip-text">{{item.status}}</span>
            </v-tooltip>
          </div>
          <div v-else>{{ item.status }}</div>
        </template>

        <template #[`item.alertName`]="{ item }">
          <div class="d-flex justify-center">
            <div v-if="!hasAlerts(item)">-</div>
            <div v-else class="d-flex justify-center">
              <div v-for="(alert, index) in item.alerts.slice(0, 2)" :key="index" class="d-flex justify-center mr-2">
                <v-tooltip v-if="alert.alertName !== '-'" top content-class="tooltip-content">
                  <template v-slot:activator="{ on, attrs }">
                    <p
                      class="circle"
                      :style="{
                        backgroundColor: alertStatuses[alert.alertName],
                        borderRadius: 0
                      }"
                      v-bind="attrs"
                      v-on="on"
                    ></p>
                  </template>
                  <span class="tooltip-text" >{{ alertStatusesLabel[alert.alertName] }} -
                    {{ convertValue(alert.alertName, alert.alertValue) }}
                    {{ getUnit(alert.alertName) }}
                  </span>
                </v-tooltip>
                <span v-else>{{ alert.alertName }}</span>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <div class="d-flex">
            <p
              @click.stop="!['UNASSIGNED','UNASSIGNING'].includes(item.state) &&editDialogOpen(item)"
               :class="{ 'disabled-pointer': ['UNASSIGNED', 'UNASSIGNING'].includes(item.state), 'pointer': !['UNASSIGNED', 'UNASSIGNING'].includes(item.state) }"
               class="d-inline-block mr-2"
            >
              <v-icon size="24" class=" darken-2" :style="{ color: ['UNASSIGNED', 'UNASSIGNING'].includes(item.state) ? '#A0A0A0' : '#001e38' }"
                >mdi-square-edit-outline</v-icon
              >
            </p>
            <p @click.stop="deleteItem(item)" :style="{ cursor: !btnAction ? 'pointer' : 'not-allowed' }"
            :class="{ 'disabled-icon': btnAction }" class="d-inline-block">
              <v-icon size="24" class="red--text darken-2"
                >mdi-trash-can-outline</v-icon
              >
            </p>
          </div>
        </template>
      </v-data-table>
      <div class="table-options" >
        <div>
          <v-btn @click="addSensor" :disabled="btnAction" text class="btn">{{
            $t("Add Sensor")
          }}</v-btn>
          <v-btn @click="assignSensor(SelectedsensorValue)" :disabled="SelectedsensorValue.length !==1 || btnAction" text class="btn ml-3">{{
            $t("Assign")
          }}</v-btn>

        <v-btn :disabled="SelectedsensorValue.length===0 || btnAction" @click="unassignSensor()" text class="btn ml-3">{{
            $t("Unassign")
          }}</v-btn>
             <v-btn :disabled="SelectedsensorValue.length!==1 || btnAction" @click="exportRecords()" text class="btn ml-3">{{
            $t("Export")
          }}</v-btn>
        </div>

      </div>
      <div class="col-12 pr-0" style="padding:0px;margin: auto">
      <Pagination @paging="paging($event)" :pageInfoText="pageInfoText" :pageIndex="pageIndex" :rowPerPage="rowPerPage"
        :goToPageInput="goToPageInput" :totalPages="totalPages" @updatePage="updatePage($event)"></Pagination>
    </div>
    </div>
    <DeleteConfirmation
      v-if="deleteConfirmation"
      :dialogConfirm="deleteConfirmation"
      @confirmAction="deleteAction($event)"
    />
    <AddSensor
      v-if="addSensorDialog"
      :addDialogPopup="addSensorDialog"
      @closeAddModal="addSensorDialog = false"
    />
    <SensorDetails
      v-if="sensorDetailsDialog"
      :addDialogPopup="sensorDetailsDialog"
      @closeAddModal="closeSensorDetailsDialog"
      :sensorDetails="sensorDetails"
      @openEditDialog="editDialogOpen($event)"
    />
    <AlertDetails
      v-if="alertDetailsDialog"
      :alertDialogPopup="alertDetailsDialog"
      @closeAlertModal="closeAlertDetailsDialog"
      :alertDetails="alertDetails"
    />
    <EditSensor
      v-if="editSensorDialog"
      :addDialogPopup="editSensorDialog"
      :editList="editData"
      @closeEditModal="closeEditSensorDialog"
    />
    <!-- <RedirectOverview
      v-if="redirectEnable"
      :messageDialog="redirectEnable"
      @redirect="goToOverviewPage"
    /> -->

    <v-dialog
      v-model="exportDialogVisible"
      width="600"
        persistent
    >
      <div style="padding: 40px 50px;background-color:#fff;position:relative">
        <h2 class="page-title-bar mb-5">
          <i class="ico ico-product"></i>{{ $t("Sensor Log Export") }}
        </h2>
        <div class="product_detail">
          <!-- Sensor ID display -->
          <div class="sensor-id-row mb-4">
            <label class="sensor-id-label">{{ $t('Sensor ID') }}: </label>{{ SelectedsensorValue.length > 0 && SelectedsensorValue[0].sensorCode? SelectedsensorValue[0].sensorCode: '-' }}
          </div>

          <div class="date-row d-flex align-center">
            <div class="date-col">
              <label class="field-label">{{ $t('Start Time') }} <span class="required-star">*</span></label>
                <v-menu
                  v-model="showStartDatePicker"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="250px"
                class="start-menu"
              >
                <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="scheduleTime"
                      @click:clear="scheduleTime = null"
                      :placeholder="`${$t('Select Start Time')}`"
                      class="form-select mb-4 mandatory mt-1"
                      v-bind="attrs"
                      v-on="on"
                      outlined
                      dense
                      hide-details
                      readonly
                      clearable
                      prepend-icon=""
                      append-icon="mdi-calendar-month"
                      ref="calendarstart"
                      style="padding-top: 0px;"
                      @click="setCurrentDate('start')"
                      @click:append="$refs.calendarstart.$el.querySelector('input').click()"
                    />
                </template>
                <v-card flat>
                    <v-card-text class="pa-0">
                    <date-picker
                      mode="dateTime"
                      v-model="startTime"
                      :min-date="startMinDate"
                      :max-date="new Date()"
                      :minute-increment="30"
                      :is-required="true"
                      is24hr
                      :show-current="false"
                    />
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer />
                    <v-btn class="btn cancel-btn" style="width: 100px!important;" dark small text @click="showStartDatePicker = false">{{ $t('Apply') }}</v-btn>
                  </v-card-actions>
                </v-card>
              </v-menu>
            </div>

            <div class="date-col">
              <label class="field-label">{{ $t('End Time') }} <span class="required-star">*</span></label>
              <v-menu
                v-model="showEndDatePicker"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="250px"
                class="end-menu"
              >
                <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="scheduleEndTime"
                      @click:clear="scheduleEndTime = null"
                      :placeholder="`${$t('Select End Time')}`"
                      class="form-select mb-4 mandatory"
                      v-bind="attrs"
                      v-on="on"
                      outlined
                      dense
                      hide-details
                      readonly
                      clearable
                      prepend-icon=""
                      append-icon="mdi-calendar-month"
                      ref="calendarend"
                      style="padding-top: 0px;"
                      @click="setCurrentDate('end')"
                      @click:append="$refs.calendarend.$el.querySelector('input').click()"
                    />
                </template>
                <v-card flat>
                    <v-card-text class="pa-0">
                    <date-picker
                      mode="dateTime"
                      v-model="endTime"
                      :min-date="startTime"
                      :max-date="new Date()"
                      :minute-increment="30"
                      :is-required="true"
                      is24hr
                      :show-current="false"
                    />
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer />
                    <v-btn style="width: 100px!important;" class="btn cancel-btn" dark small text @click="showEndDatePicker = false">{{ $t('Apply') }}</v-btn>
                  </v-card-actions>
                </v-card>
              </v-menu>
            </div>
          </div>

          <div class="export-note mt-3 mb-3">
            <v-icon small color="error" class="mr-2">mdi-alert-circle</v-icon>
            <p>{{ $t('Exporting a large volume of records may take some time to process. The file will be available for download Sensor Export Records page.') }}</p>
          </div>
          <div v-if="scheduleTime && scheduleEndTime && !isScheduleValid" class="field-error mt-2">
            {{ $t('End Time must be the same or after Start Time.') }}
          </div>
          <div class="required-legend mb-2">*{{ $t('Required fields') }}</div>
        </div>
        <v-card-actions class="pa-6">
          <div class="dialog-buttons">
            <v-btn @click="exportDialogVisible = false" class="btn cancel-btn" dark>{{ $t('Cancel') }}</v-btn>
            <v-btn @click="handleSaveClick" :disabled="!isScheduleValid" class="btn primary-btn" dark>{{ $t('Export') }}</v-btn>
          </div>
        </v-card-actions>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import EventBus from '@/plugins/eventBus'
import Pagenation from '@/mixins/Pagenation'
import DeleteConfirmation from '@/components/modal/DeleteConfirmtion.vue'
import AddSensor from './model/AddSensor.vue'
import SensorDetails from './model/SensorDetails.vue'
import AlertDetails from './model/AlertDetails.vue'
import EditSensor from './model/EditSensor.vue'
import GradientDonutChart from '@/components/ApexCharts/GradientDonutChart.vue'
// import Toggle from '@/components/Toggle.vue'
import StackChart from '@/components/Charts/StackChart'
import { mapGetters } from 'vuex'
import codes from '@/plugins/codes'
import moment from 'moment'
import commons from '@/plugins/commons'
import { DatePicker } from 'v-calendar'
import Pagination from '@/components/pagination/Pagination.vue'

export default {
  mixins: [Pagenation],
  components: {
    DeleteConfirmation,
    AddSensor,
    SensorDetails,
    AlertDetails,
    EditSensor,
    GradientDonutChart,
    // Toggle,
    StackChart,
    Pagination,
    DatePicker
  },
  data () {
    return {
      deviceLoading: false,
      alertLoading: false,
      noData: false,
      redirectEnable: false,
      stackColor: ['#001E38', '#001E3880', '#FF8097', '#6DA3F8'],
      categories: [],
      stackChartData: [
        {
          name: 'High Temperature',
          data: [],
          borderRadiusTopLeft: '10px',
          borderRadiusTopRight: '10px'
        },
        {
          name: 'Low Temperature',
          data: []
        },
        {
          name: 'High Humidity',
          data: []
        },
        {
          name: 'Low Humidity',
          data: []
        }
      ],
      toggleState: true,
      alertActive: 'Active',
      legendPosBottom: {
        show: false,
        position: 'bottom',
        formatter: function (val, opts) {
          return val + ' - ' + opts.w.globals.series[opts.seriesIndex]
        },
        fontFamily: "'Source Sans Pro', sans-serif'",
        fontSize: '12px',
        itemMargin: {
          horizontal: 10
        },
        markers: {
          offsetX: -5 // Adjust the horizontal offset between the symbol and text
        },
        style: {
          fontSize: '14px',
          fontWeight: 'bold'
        }
      },
      donutChartPlotOptions: {
        pie: {
          expandOnClick: false,
          donut: {
            size: '60',
            labels: {
              show: true,
              value: {
                show: true,
                fontSize: '26px',
                fontFamily: "'Source Sans Pro', sans-serif'",
                fontWeight: 'bold',
                offsetY: 10
              },
              total: {
                show: true,
                showAlways: true,
                label: '',
                fontSize: '14px',
                fontWeight: 'bold',
                fontFamily: "'Source Sans Pro', sans-serif'",
                color: '#8394b4',
                formatter: function (w) {
                  const totalValue = w.globals.seriesTotals.reduce(
                    (a, b) => a + b,
                    0
                  )
                  if (totalValue === 0) return 0
                  return Number(totalValue)
                    .toFixed(0)
                    .replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, '$1,')
                }
              }
            }
          }
        }
      },
      optionEnable: {
        enabled: false,
        style: {
          fontSize: '10px',
          fontFamily: "'Source Sans Pro', sans-serif'",
          fontWeight: 'bold'
        }
      },
      tooltip: {
        custom: function ({ series, seriesIndex, dataPointIndex, w }) {
          return (
            '<div class="arrow_box1">' +
            '<span>' +
            w.config.labels[seriesIndex] +
            ' : ' +
            series[seriesIndex] +
            '</span>' +
            '</div>'
          )
        }
      },
      connectivity: [],
      battery: [],
      activeAlert: [],
      activeAlertLabels: [
        'High Temperature',
        'Low Temperature',
        'High Humidity',
        'Low Humidity'
      ],
      alertStatuses: {
        HIGH_TEMPERATURE: '#001E38',
        LOW_TEMPERATURE: '#001E3880',
        HIGH_HUMIDITY: '#FF8097',
        LOW_HUMIDITY: '#6DA3F8'
      },
      alertStatusesLabel: {
        HIGH_TEMPERATURE: 'High Temperature',
        LOW_TEMPERATURE: 'Low Temperature',
        HIGH_HUMIDITY: 'High Humidity',
        LOW_HUMIDITY: 'Low Humidity'
      },
      batteryLabels: ['Good', 'Bad'],
      batteryColor: ['#001E38', '#FF8097'],
      activeAlertColor: ['#001E38', '#001E3880', '#FF8097', '#6DA3F8'],
      color: ['#001E38', '#EAEEF7'],
      connectivityLabels: ['Connected', 'Disconnected'],
      editSensorDialog: false,
      sensorDetails: {},
      alertDetails: {},
      editData: {},
      deleteConfirmation: false,
      addSensorDialog: false,
      sensorDetailsDialog: false,
      alertDetailsDialog: false,
      deleteData: {},
      rowPerPage: '10',
      page: 1,
      totalPages: 1,
      pageIndex: 1,
      rowPerPageList: [5, 10, 20, 50, 100],
      pageInfoText: '',
      totalVisiblePages: 5,
      itemsPerPage: 10,
      totalProducts: null,

      goToPageInput: 1,
      sensorStatusList: [
        {
          text: 'Online',
          val: 'Online'
        },
        {
          text: 'Offline',
          val: 'Offline'
        }
      ],
      sensorStateList: [
        {
          value: 'SUCCESS',
          text: this.$t('SUCCESS')
        },
        {
          value: 'PROCESSING',
          text: this.$t('PROCESSING')
        },
        {
          value: 'TIMEOUT',
          text: this.$t('TIMEOUT')
        },
        {
          value: 'UNASSIGNED',
          text: this.$t('UNASSIGNED')
        }
      ],
      durationList: [
        {
          text: 'Last 1 Hour',
          val: 1
        },
        {
          text: 'Last 2 Hours',
          val: 2
        },
        {
          text: 'Last 6 Hours',
          val: 6
        },
        {
          text: 'Last 12 Hours',
          val: 12
        },
        {
          text: 'Last 1 Day',
          val: 24
        },
        {
          text: 'Last 2 Days',
          val: 48
        },
        {
          text: 'Last 1 Week',
          val: 168
        }
      ],
      selectedDuration: 1,
      startDate: null,
      endDate: null,
      searchBy: {
        sensorName: null,
        sensorId: null,
        sensorStatus: null,
        location: null,
        sort: null,
        state: []
      },
      options: {
        sortBy: [],
        sortDesc: []
      },
      tableItems: [],
      SelectedsensorValue: [],
      btnAction: false,
      btnActionDetails: false,
      maxDisplay: 1,
      statelist: [],
      exportDialogVisible: false,
      showStartDatePicker: false,
      showEndDatePicker: false,
      // export dialog scheduling
      schedule: {},
      scheduleTime: '',
      scheduleEndTime: '',
      startTime: new Date(),
      endTime: new Date(new Date().getTime() + 60 * 60 * 1000),
      retentionPeriodEnabled: false,
      menuOpen: false,
      visibleColumns: []
    }
  },
  computed: {
    isAllSelected () {
      return (
        this.tableHeaders.length > 0 &&
        this.visibleColumns.length === this.tableHeaders.length - 4
      )
    },
    filteredTableHeaders () {
      return this.tableHeaders.filter(h =>
        h.value === 'serialNo' ||
        h.value === 'name' ||
        h.value === 'sensorCode' ||
        h.value === 'action' ||
        this.visibleColumns.includes(h.text)
      )
    },
    // isSensorEnable () {
    //   if (
    //     Object.keys(this.$store.getters['dataStore/GET_FUNCTIONS']).length === 0
    //   ) {
    //     return false
    //   }
    //   return this.$store.getters['dataStore/GET_FUNCTIONS'].sensors
    // },
    ...mapGetters({ store: 'dataStore/GET_SELECTED_STORE' }),
    getUnit () {
      return (alertName) => {
        if (alertName ?.includes('HUMIDITY')) {
          return '%'
        }
        return JSON.parse(localStorage.getItem('tempIndicator')) ? '°C' : '°F'
      }
    },
    convertValue () {
      return (alertName, value) => {
        if (alertName ?.includes('HUMIDITY')) {
          return value
        }

        const isCelsius = JSON.parse(localStorage.getItem('tempIndicator')) // true means Celsius, false means Fahrenheit

        if (isCelsius) {
          return value
        } else {
          return ((value * 9 / 5) + 32).toFixed(2)
        }
      }
    },
    selectedStore () {
      return this.$store.getters['dataStore/GET_SELECTED_STORE'].code
    },
    tableHeaders () {
      return [
        {
          text: this.$t('#'),
          align: 'center',
          sortable: false,
          value: 'serialNo'
        },
        {
          text: this.$t('SENSOR NAME'),
          align: 'center',
          sortable: false,
          value: 'name'
        },
        {
          text: this.$t('SENSOR ID'),
          align: 'center',
          sortable: false,
          value: 'sensorCode'
        },
        {
          text: this.$t('STATUS'),
          align: 'center',
          sortable: false,
          value: 'status'
        },
        {
          text: this.$t('ALERT STATUS'),
          align: 'center',
          sortable: false,
          value: 'alertName'
        },
        {
          text: this.$t('LOCATION'),
          align: 'center',
          sortable: false,
          value: 'assignedTo'
        },
        {
          text: this.$t('BATTERY'),
          align: 'center',
          sortable: false,
          value: 'battery'
        },
        {
          text: this.$t('SIGNAL STRENGTH'),
          align: 'center',
          sortable: false,
          value: 'signalStrength'
        },
        {
          text: this.$t('FW. VER'),
          align: 'center',
          sortable: false,
          value: 'fwVersion'
        },
        {
          text: this.$t('STATE'),
          align: 'center',
          sortable: false,
          value: 'state'
        },
        {
          text: this.$t('GATEWAY'),
          align: 'center',
          sortable: false,
          value: 'gatewayIpAddress'
        },
        {
          text: this.$t('LAST RESPONSE TIME'),
          align: 'center',
          sortable: true,
          value: 'statusUpdateTime'
        },
        {
          text: '',
          align: 'center',
          sortable: false,
          value: 'action'
        }
      ]
    },
    isScheduleValid () {
      if (!this.scheduleTime || !this.scheduleEndTime) return false
      try {
        return new Date(this.endTime) >= new Date(this.startTime)
      } catch (e) {
        return false
      }
    },
    startMinDate () {
      const now = new Date()
      if (this.retentionPeriodEnabled) {
        const d = new Date(now.getTime())
        d.setFullYear(d.getFullYear() - 1)
        return d
      }
      return new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000)
    }
  },
  watch: {
    options: {
      handler (newVal, oldVal) {
        if (oldVal !== undefined) {
          if (newVal.sortDesc !== oldVal.sortDesc) {
            let sortParam = ''
            if (newVal.sortBy.length && newVal.sortDesc[0]) {
              sortParam += newVal.sortBy[0] + ',DESC'
            } else if (newVal.sortBy.length && !newVal.sortDesc[0]) {
              sortParam += newVal.sortBy[0] + ',ASC'
            }
            this.searchBy.sort = sortParam
            this.getSensorList(1)
          }
        }
      },
      deep: true,
      immediate: true
    },
    page: {
      handler (page) {
        this.goToPageInput = page
      }
    },
    store: {
      handler () {
        if (
          this.store === undefined ||
          !this.store.code ||
          this.store.code === ''
        ) {
          EventBus.$emit('openSelectedStores')
          this.tableItems = []
          this.totalProducts = null
          this.totalPages = 1
          this.pageInfoText = ''
          this.page = 1
          this.pageIndex = 1
          this.goToPageInput = 1
          this.SelectedsensorValue = []
          this.connectivity = []
          this.battery = []
          this.activeAlert = []
          this.categories = []
          this.stackChartData = [
            { name: 'High Temperature', data: [] },
            { name: 'Low Temperature', data: [] },
            { name: 'High Humidity', data: [] },
            { name: 'Low Humidity', data: [] }
          ]
          this.searchBy = { sensorName: null, sensorId: null, sensorStatus: null, location: null, sort: null, state: [] }
          return
        }
        this.getSensorList(1)
        this.getDeviceStatus()
        if (this.alertActive === 'History') {
          this.getAlertHistory()
        } else {
          this.getActiveAlert()
        }
      }
    },

    // sync formatted strings and enforce end >= start
    startTime (value) {
      this.scheduleTime = moment(value).format('YYYY-MM-DDTHH:mm:ss')
      try {
        if (new Date(this.endTime) < new Date(value)) {
          const newEnd = new Date(value.getTime() + 60 * 60 * 1000)
          this.endTime = newEnd
          this.scheduleEndTime = moment(newEnd).format('YYYY-MM-DDTHH:mm:ss')
        }
      } catch (e) {}
    },
    endTime (value) {
      this.scheduleEndTime = moment(value).format('YYYY-MM-DDTHH:mm:ss')
    }

    // isSensorEnable (val) {
    //   if (!val) {
    //     this.redirectEnable = true
    //   }
    // }
  },
  mounted () {
    this.$store.dispatch('auth/getDisabledBtn', '13101').then(flag => {
      this.btnAction = flag
    })
    this.$store.dispatch('auth/getDisabledBtn', '13102').then(flag => {
      this.btnActionDetails = flag
    })
    // if (localStorage.getItem('tempIndicator') !== null) {
    //   this.toggleState = JSON.parse(localStorage.getItem('tempIndicator'))
    // } else {
    //   this.toggleState = true
    //   localStorage.setItem('tempIndicator', 'true')
    // }
    EventBus.$emit('enableSelectedStores', true)
    if (
      this.store === undefined ||
      !this.store.code ||
      this.store.code === ''
    ) {
      EventBus.$emit('openSelectedStores')
    } else {
      this.toGetSensorScaleValue()
      this.toGetretentionPeriod()
      const currentDate = new Date()
      // this.startDate = moment(
      //   currentDate.setHours(currentDate.getHours() - 1)
      // ).utc().format('YYYY-MM-DDTHH:mm:ss')
      // this.endDate = moment(new Date()).utc().format('YYYY-MM-DDTHH:mm:ss')
      this.startDate = moment(
        currentDate.setHours(currentDate.getHours() - 1)).format('YYYY-MM-DDTHH:mm:ss')
      this.endDate = moment(new Date()).format('YYYY-MM-DDTHH:mm:ss')
      this.getSensorList(1)
      this.getDeviceStatus()
      this.getActiveAlert()
      this.togetCustomCloumn()
    }
  },
  created () {
    if (localStorage.getItem('tempIndicator') !== null) {
      this.toggleState = JSON.parse(localStorage.getItem('tempIndicator'))
    } else {
      this.toggleState = true
      localStorage.setItem('tempIndicator', 'true')
    }
    this._updateSensorListHandler = () => {
      this.getSensorList(1)
    }
    EventBus.$on('updateSensorListEvent', this._updateSensorListHandler)
  },
  beforeDestroy () {
    EventBus.$off('updateSensorListEvent', this._updateSensorListHandler)
  },
  methods: {
    toggleSelectAll (value) {
      if (value) {
        this.visibleColumns = this.tableHeaders.slice(3, this.tableHeaders.length - 1).map(h => h.text)
      } else {
        this.visibleColumns = []
      }
    },
    togetCustomCloumn () {
      const params = { userId: this.$store.state.auth.user.account, type: 'SENSOR_LIST' }
      const config = { params: params }
      this.$utils
        .callAxios(
          codes.requests.getCustomColoumnlist.method,
          codes.requests.getCustomColoumnlist.url,
          config
        )
        .then(res => {
          if (res.status === 200) {
            console.log(res.data)
            const data = res.data
            const apiColumns = data['13100'] || []
            if (apiColumns.length > 0) {
              this.visibleColumns = apiColumns.filter(text =>
                this.tableHeaders.some(h => h.text === text)
              )
            } else {
              this.visibleColumns = []
            }
          } else {
            this.visibleColumns = this.tableHeaders.map(h => h.text)
          }
        })
        .catch(error => {
          console.log(error)
          this.visibleColumns = this.tableHeaders.map(h => h.text)
        })
    },
    saveVisibleColumns () {
      const body = {
        13100: this.visibleColumns
      }
      const params = { userId: this.$store.state.auth.user.account, type: 'SENSOR_LIST' }
      this.$utils
        .callAxiosWithBody(
          codes.requests.updateCustomColoumnlist.method,
          codes.requests.updateCustomColoumnlist.url,
          body,
          { params: params }
        )
        .then(res => {
          if (res.status === 200) {
            console.log(res.data)
            EventBus.$emit('messageAlert', this.$t(res.data.responseMessage))
            this.togetCustomCloumn()
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    setCurrentDate (e) {
      const type = e || 'start'
      if (type === 'start') {
        if (!this.scheduleTime) {
          setTimeout(() => {
            this.scheduleTime = moment().format('YYYY-MM-DD HH:00')
            this.startTime = new Date()
            // reset endTime to start + 1 hour
            this.endTime = new Date(this.startTime.getTime() + 60 * 60 * 1000)
            this.scheduleEndTime = moment(this.endTime).format('YYYY-MM-DDTHH:mm:ss')
          }, 200)
        }
      } else {
        if (!this.scheduleEndTime) {
          setTimeout(() => {
            this.scheduleEndTime = moment(new Date()).format('YYYY-MM-DD HH:00')
            this.endTime = new Date()
          }, 200)
        }
      }
    },

    hasAlerts (item) {
      return Array.isArray(item?.alerts) && item.alerts.length > 0
    },
    updateDuration (e) {
      let start = null
      let end = null
      if (e === 1) {
        start = new Date().setHours(new Date().getHours() - 1)
        end = new Date()
      } else if (e === 2) {
        start = new Date().setHours(new Date().getHours() - 2)
        end = new Date()
      } else if (e === 6) {
        start = new Date().setHours(new Date().getHours() - 6)
        end = new Date()
      } else if (e === 12) {
        start = new Date().setHours(new Date().getHours() - 12)
        end = new Date()
      } else if (e === 24) {
        start = new Date().setHours(new Date().getHours() - 24)
        end = new Date()
      } else if (e === 48) {
        start = new Date(new Date().getTime() - 2 * 24 * 60 * 60 * 1000)
        end = new Date()
      } else if (e === 168) {
        start = new Date(new Date().getTime() - 7 * 24 * 60 * 60 * 1000)
        end = new Date()
      }
      // this.startDate = moment(start).utc().format('YYYY-MM-DDTHH:mm:ss')
      // this.endDate = moment(end).utc().format('YYYY-MM-DDTHH:mm:ss')
      this.startDate = moment(start).format('YYYY-MM-DDTHH:mm:ss')
      this.endDate = moment(end).format('YYYY-MM-DDTHH:mm:ss')
      this.getAlertHistory()
    },
    goToOverviewPage () {
      this.$emit('closeMainStoreModal', null, false)
      this.messageDialog = false
      EventBus.$emit('returnToOverviewPage')
    },
    updatePage (event) {
      this.rowPerPage = event.toString()
      this.paging(1)
    },
    buildSensorListParams () {
      const { sortBy, sortDesc, itemsPerPage } = this.options
      const params = {
        company: this.$store.state.auth.user.company,
        store: this.selectedStore,
        name: this.searchBy.sensorName,
        id: this.searchBy.sensorId,
        status: this.searchBy.sensorStatus,
        location: this.searchBy.location,
        sort: this.searchBy.sort,
        state: this.searchBy.state
      }
      if (params.state?.length === 0) {
        params.state = null
      }

      if (sortBy && sortBy.length === 1 && sortDesc && sortDesc.length === 1) {
        const sortKey = sortBy[0]
        const sortOrder = sortDesc[0] ? 'desc' : 'asc'
        params.sort = `${sortKey},${sortOrder}`
      }

      if (itemsPerPage > 0) {
        params.size = Number(this.rowPerPage)
      }

      return params
    },

    getSensorList (page) {
      this.tableItems = []
      const params = this.buildSensorListParams()
      if (page !== null) params.page = page - 1
      const config = { params: params }
      this.$utils
        .callAxios(
          codes.requests.togetSensorList.method,
          codes.requests.togetSensorList.url,
          config
        )
        .then(res => {
          const headers = res.headers
          if (res.status === 200) {
            this.tableItems = res.data.sensorsList.map((obj, idx) => {
              return {
                serialNo: headers['x-number'] * 1 * headers['x-size'] + idx + 1,
                // Spread the object properties and handle null values
                ...Object.keys(obj).reduce((acc, key) => {
                  acc[key] = obj[key] == null ? '-' : obj[key]
                  return acc
                }, {}),
                statusUpdateTime: commons.convertDate(obj.statusUpdateTime)
                // status: res.data.sensorsList
              }
            })
          } else {
            this.tableItems = []
          }
          this.pageInfoText = commons.getPageInfoText(res.headers)
          this.totalPages = Number(res.headers['x-totalpages'])
          this.pageIndex = res.headers['x-number'] * 1 + 1
          this.pageCount = res.headers['x-totalpages'] * 1
        }).catch(error => {
          this.tableItems = []
          if (
            error &&
            error.response &&
            error.response.data &&
            error.response.data.responseMessage
          ) {
            EventBus.$emit(
              'messageAlert',
              this.$t(error.response.data.responseMessage),
              'error'
            )
          } else {
            EventBus.$emit('messageAlert', this.$t(error), 'error')
          }
          console.log(this.tableItems)
        })
    },

    getDeviceStatus () {
      this.deviceLoading = true
      const config = {
        params: {
          company: this.$store.state.auth.user.company,
          store: this.selectedStore
        }
      }
      this.$utils
        .callAxios(
          codes.requests.togetSensorListSummary.method,
          codes.requests.togetSensorListSummary.url,
          config
        )
        .then(res => {
          this.deviceLoading = false
          if (res.status === 200) {
            this.connectivity = [
              res.data.summary.connected,
              res.data.summary.disconnected
            ]
            this.battery = [
              res.data.summary.goodBattery,
              res.data.summary.badBattery
            ]
          } else {
            this.connectivity = []
            this.battery = []
          }
        })
        .catch(error => {
          this.deviceLoading = false
          EventBus.$emit(
            'messageAlert',
            this.$t(error.response.data.responseMessage),
            'error'
          )
        })
    },

    getActiveAlert () {
      this.alertLoading = true
      const config = {
        params: {
          company: this.$store.state.auth.user.company,
          store: this.selectedStore
        }
      }
      this.$utils
        .callAxios(
          codes.requests.getactiveAlertHistory.method,
          codes.requests.getactiveAlertHistory.url,
          config
        )
        .then(res => {
          this.alertLoading = false
          if (res.status === 200) {
            this.activeAlert = [
              res.data.alertResponse.highTemperature,
              res.data.alertResponse.lowTemperature,
              res.data.alertResponse.highHmdt,
              res.data.alertResponse.lowHmdt
            ]
          } else {
            this.activeAlert = []
          }
        })
        .catch(error => {
          this.alertLoading = false
          this.activeAlert = []
          EventBus.$emit(
            'messageAlert',
            this.$t(error.response.data.responseMessage),
            'error'
          )
        })
    },
    getAlertHistory () {
      console.log(this.endDate)
      this.alertLoading = true
      const config = {
        params: {
          company: this.$store.state.auth.user.company,
          store: this.selectedStore,
          startTime: this.startDate,
          endTime: this.endDate,
          hours: this.selectedDuration
        }
      }
      this.stackChartData[0].data = []
      this.stackChartData[1].data = []
      this.stackChartData[2].data = []
      this.stackChartData[3].data = []
      this.categories = []
      this.$utils
        .callAxios(
          codes.requests.getactiveAlertHistorySummary.method,
          codes.requests.getactiveAlertHistorySummary.url,
          config
        )
        .then(res => {
          this.alertLoading = false
          if (res.status === 200) {
            this.stackChartData[0].data = res.data.alertHistorySummary.map(
              obj => obj.highTemperature
            )
            this.stackChartData[1].data = res.data.alertHistorySummary.map(
              obj => obj.lowTemperature
            )
            this.stackChartData[2].data = res.data.alertHistorySummary.map(
              obj => obj.highHmdt
            )
            this.stackChartData[3].data = res.data.alertHistorySummary.map(
              obj => obj.lowHmdt
            )
            if (this.selectedDuration === 1 || this.selectedDuration === 2 || this.selectedDuration === 6 || this.selectedDuration === 12) {
              this.categories = res.data.alertHistorySummary.map(obj => moment(commons.convertDate(obj.duration)).format('HH:mm'))
            } else if (this.selectedDuration === 168) {
              this.categories = res.data.alertHistorySummary.map(obj => moment(commons.convertDate(obj.duration)).format('DD-MM-YYYY'))
            } else {
              this.categories = res.data.alertHistorySummary.map(obj => moment(commons.convertDate(obj.duration)).format('DD-MM-YYYY HH:mm'))
            }
          }
        })
        .catch(error => {
          this.alertLoading = false
          EventBus.$emit(
            'messageAlert',
            this.$t(error.response.data.responseMessage),
            'error'
          )
        })
    },
    handleAlertBox (active) {
      if (active === this.alertActive) return
      this.alertActive = active
      if (active === 'History') {
        // this.getAlertHistory()
        this.selectedDuration = 1
        this.updateDuration(1)
      } else {
        this.getActiveAlert()
      }
    },
    // valueChanged (e) {
    //   localStorage.setItem('tempIndicator', e)
    //   this.toggleState = e
    //   this.toPutSensorScaleValue(e)
    // },
    goToPage (goToPageInput, paging, totalPages) {
      if (totalPages < goToPageInput) {
      } else {
        paging(Number(goToPageInput))
      }
    },
    openSensorDetails (data) {
      if (!this.btnActionDetails) {
        this.sensorDetails = data
        this.sensorDetailsDialog = true
      }
    },
    closeSensorDetailsDialog () {
      this.sensorDetails = {}
      this.sensorDetailsDialog = false
    },
    openAlertDialog (data, chart) {
      if (chart === 'donut') {
        this.alertDetails = {
          name: this.activeAlertLabels[data],
          value: this.activeAlert[data],
          type: 'active'
        }
      } else {
        this.alertDetails = {
          name: this.stackChartData[data].name,
          value: this.stackChartData[data].data.reduce(
            (accumulator, currentValue) => accumulator + currentValue,
            0
          ),
          type: 'history',
          startTime: this.startDate,
          endTime: this.endDate
        }
      }

      this.alertDetailsDialog = true
    },
    closeAlertDetailsDialog () {
      this.alertDetails = {}
      this.alertDetailsDialog = false
    },
    clickSearch () {
      this.SelectedsensorValue = []
      this.paging(1)
    },
    clearSearch () {
      this.searchBy = {
        sensorName: null,
        sensorId: null,
        state: [],
        sensorStatus: null,
        location: null,
        sort: null
      }
      this.statelist = []
      this.SelectedsensorValue = []
      this.paging(1)
    },
    paging (page) {
      this.page = Number(page)
      this.goToPageInput = page
      this.options.itemsPerPage = Number(this.rowPerPage)
      this.getSensorList(page)
    },
    editDialogOpen (data) {
      if (!this.btnAction) {
        delete data.action
        this.editData = data
        this.editSensorDialog = true
      }
    },
    closeEditSensorDialog () {
      this.editData = {}
      this.editSensorDialog = false
      this.SelectedsensorValue = []
    },
    deleteItem (data) {
      this.deleteConfirmation = true
      this.deleteData = data
    },
    deleteAction (action) {
      if (action === 'Yes') {
        this.deleteConfirmation = false
        this.deleteSensor()
      } else {
        this.deleteConfirmation = false
      }
      this.deleteData = {}
    },
    // Export dialog save
    handleSaveClick () {
      if (!this.scheduleTime) {
        EventBus.$emit('messageAlert', this.$t('Select Start Time.'))
        return
      }
      if (!this.scheduleEndTime) {
        EventBus.$emit('messageAlert', this.$t('Select End Time.'))
        return
      }
      if (new Date(this.endTime) < new Date(this.startTime)) {
        EventBus.$emit('messageAlert', this.$t('The period is invalid.'))
        return
      }
      // Emit event with chosen range and selected sensors
      const config = {
        params: {
          company: this.$store.state.auth.user.company,
          store: this.selectedStore,
          sensorCode: this.SelectedsensorValue.map((ssv) => (ssv.sensorCode)).toString(),
          startTime: this.scheduleTime,
          endTime: this.scheduleEndTime,
          export: true
        }
      }
      this.$utils
        .callAxios(
          codes.requests.getSensorLogsDetails.method,
          codes.requests.getSensorLogsDetails.url,
          config
        )
        .then(res => {
          console.log(res)
          EventBus.$emit('messageAlert', this.$t('The request has been completed'))
        })
        .catch(error => {
          EventBus.$emit(
            'messageAlert',
            this.$t(error.response.data.responseMessage),
            'error'
          )
        })
      this.exportDialogVisible = false
    },
    unassignSensor () {
      const config = {
        params: {
          company: this.$store.state.auth.user.company,
          store: this.selectedStore
        },
        data: this.SelectedsensorValue.map((ssv) => (ssv.sensorCode))
      }
      this.$utils
        .callAxios(
          codes.requests.unassignMultipleSensors.method,
          codes.requests.unassignMultipleSensors.url,
          config
        )
        .then(res => {
          if (res.status === 200) {
            EventBus.$emit('messageAlert', this.$t(res.data.returnMsg))
            this.paging(1)
            this.SelectedsensorValue = []
          } else {
            EventBus.$emit(
              'messageAlert',
              this.$t('Something went wrong. Please try after some time.')
            )
            this.SelectedsensorValue = []
          }
        })
        .catch(error => {
          const message = error?.response?.data?.returnMsg
            ? this.$t(error.response.data.returnMsg)
            : this.$t('Something went wrong. Please try again.')
          EventBus.$emit('messageAlert', message)
          this.SelectedsensorValue = []
        })
    },
    deleteSensor () {
      const config = {
        params: {
          company: this.$store.state.auth.user.company,
          store: this.selectedStore,
          sensorCode: this.deleteData.sensorCode
        }
      }
      this.$utils
        .callAxios(
          codes.requests.toDeleteSensorList.method,
          codes.requests.toDeleteSensorList.url,
          config
        )
        .then(res => {
          if (res.status === 200) {
            EventBus.$emit('messageAlert', this.$t(res.data.returnMsg))
            this.paging(1)
          } else {
            EventBus.$emit(
              'messageAlert',
              this.$t('Something went wrong. Please try after some time.')
            )
          }
        })
        .catch(error => {
          EventBus.$emit(
            'messageAlert',
            this.$t(error.response.data.responseMessage),
            'error'
          )
        })
    },
    addSensor () {
      this.addSensorDialog = true
    },
    assignSensor (data) {
      console.log(data)
      this.editSensorDialog = true
      data[0].action = 'assign'
      this.editData = data[0]
    },
    toGetSensorScaleValue () {
      const config = {
        params: {
          company: this.$store.state.auth.user.company,
          store: this.selectedStore
        }
      }
      this.$utils
        .callAxios(
          codes.requests.toGetSensorScale.method,
          codes.requests.toGetSensorScale.url,
          config
        )
        .then(res => {
          if (res.status === 200) {
            if (res.data.scale === 'F') {
              this.toggleState = false
              localStorage.setItem('tempIndicator', this.toggleState)
            } else {
              this.toggleState = true
              localStorage.setItem('tempIndicator', this.toggleState)
            }
          }
        })
        .catch(error => {
          this.toggleState = true
          localStorage.setItem('tempIndicator', this.toggleState)
          EventBus.$emit(
            'messageAlert',
            this.$t(error.response.data.responseMessage),
            'error'
          )
        })
    },
    onChange (val) {
      this.statelist = val
    },
    exportRecords () {
      if (this.SelectedsensorValue.length === 0) {
        EventBus.$emit('messageAlert', this.$t('Please select at least one sensor to export the logs.'))
        return
      }
      this.exportDialogVisible = true
      // Set schedule range based on retention policy
      const now = new Date()
      let start = null
      if (this.retentionPeriodEnabled) {
        // retention enabled: last 1 year
        start = new Date(now.getTime())
        start.setFullYear(start.getFullYear() - 1)
      } else {
        // retention not enabled: last 7 days
        start = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000)
      }

      this.startTime = start
      this.endTime = now
      this.scheduleTime = moment(start).format('YYYY-MM-DDTHH:mm:ss')
      this.scheduleEndTime = moment(now).format('YYYY-MM-DDTHH:mm:ss')
    },
    getSensorDetailsForExport () {
      this.chartLoader = true
      this.lineChartData.series[0].data = []
      this.tempLineChartData.series[0].data = []
      this.lineChartData.xAxis.categories = []
      this.tempLineChartData.xAxis.categories = []
      this.lineChartData.xAxis.tickInterval = 0
      this.tempLineChartData.xAxis.tickInterval = 0
      const config = {
        params: {
          company: this.$store.state.auth.user.company,
          store: this.selectedStore,
          sensorCode: this.sensorDetails.sensorCode,
          startTime: this.startDate,
          endTime: this.endDate,
          export: true
        }
      }
      this.$utils
        .callAxios(
          codes.requests.getSensorLogsDetails.method,
          codes.requests.getSensorLogsDetails.url,
          config
        )
        .then(res => {
          console.log(res)
        })
        .catch(error => {
          EventBus.$emit(
            'messageAlert',
            this.$t(error.response.data.responseMessage),
            'error'
          )
        })
    },
    toGetretentionPeriod () {
      const config = { params: {} }
      this.$utils
        .callAxios(
          codes.requests.getSensorRetentionPeriod.method,
          codes.requests.getSensorRetentionPeriod.url,
          config
        )
        .then(res => {
          if (res.status === 200) {
            console.log(res.data.retentionDays)
            if (res.data.retentionDays !== null && res.data.retentionDays !== undefined) {
              this.retentionPeriodEnabled = res.data.retentionDays > 7
              console.log(this.retentionPeriodEnabled)
            }
          }
        })
    }
  }
}
</script>
<style >
  .tooltip-content {
    background: #001E38;
    color: #fff;
  }
  .tooltip-text::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: #001E38 transparent transparent transparent;
  }
   .disabled-icon {
  opacity: 0.5 !important;
  pointer-events: none !important;
}
</style>

<style scoped>
.circle {
  height: 15px;
  width: 15px;
  border-radius: 50%;
}
.summary-card {
  min-width: 243px;
  width: 100%;
  border-radius: 5px;
  height: 400px;
  padding: 0 !important;
  background: #fff !important;
  border: 1px solid #f5f5f5;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.1);
}
.summary-card dl {
  width: 100%;
}
.w-100 {
  width: 100% !important;
}
.summary-card dt {
  display: flex;
  align-items: center;
  height: 40px;
  letter-spacing: 0;
  text-transform: none;
  text-indent: 0;
  text-align: left;
  padding-left: 10px;
  border-bottom: 2px solid #cbcbcb;
  line-height: 1.2;
  font-size: var(--font16);
  color: #001e38;
  font-weight: 400;
}
.summary-card dd {
  display: flex;
  justify-content: center;
  align-items: flex-end;
  flex-direction: column;
  height: 85px;
  padding: 0 10px;
  text-align: right;
  font-size: var(--font18);
  font-weight: 300;
  color: #4d4f5c;
  letter-spacing: -0.05em;
}
.summary-card dd p {
  line-height: 1;
}
.summary-card dd p + p {
  margin-top: 5px;
}
.summary-card dd strong {
  font-size: var(--font40);
  font-weight: 700;
}
.page-title-bar.custom {
  color: #fff;
  background-color: #001e38;
  padding: 8px;
  margin-top: 15px;
  border-radius: 5px;
}
.title-head {
  color: #a2acbd;
  padding-left: 18px;
  padding-top: 7px;
  font-size: 18px;
  font-weight: normal;
}
.title-head.active {
  color: #001e38;
}
.title-value {
  color: #4d4f5c;
  font-size: 28px;
  font-weight: bold;
}
.name {
  color: #4d4f5c;
  font-size: 12px;
}
.square-icon {
  height: 10px;
  width: 10px;
  border-radius: 2px;
}
.notification-title {
  color: #001e38;
  font-size: 18px;
  font-weight: normal;
}
.heading {
  width: 100%;
  height: 37px;
}
.scroll-box {
  height: calc(100% - 37px);
  width: 100%;
}
.notification-box {
  box-shadow: 0px 0px 20px 0px #00000029;
  height: 77px;
  background-color: #fff;
  border-radius: 5px;
  margin: 10px;
}
.summary-card.custom {
  box-shadow: none !important;
  border: 0px !important;
}
.ps {
  height: 217px;
  overflow: auto;
}
.icon {
  width: 50px !important;
  height: 100%;
}
.title-area {
  color: #4d4f5c;
  font-size: 15px;
  font-weight: bold;
  display: flex;
  align-items: center;
}
.info-area {
  color: #4d4f5c;
  font-size: 13px;
  display: flex;
}
.loader {
  border: 5px solid #eee;
  border-radius: 50%;
  border-top: 5px solid #ccc;
  width: 40px;
  height: 40px;
  -webkit-animation: spin 1s linear infinite; /* Safari */
  animation: spin 1s linear infinite;
}

/* Safari */
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.wrapper-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  flex-direction: column;
}
::v-deep .statuslistclass input {
		display: none;
	}
::v-deep .form-select.v-text-field--outlined .v-select__selections {
    display: flex !important;
    position: relative;
}
.v-btn.type-search {
    width: 160px !important;
}

/* Styles for export dialog fields to match SensorLog popup */
.sensor-id-row{
  display:flex;
  align-items:center;
}
.sensor-id-label{
  font-weight:600;
  margin-right:8px;
}
.sensor-id-value{
  max-width:420px;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
}
.sensor-id-text{display:inline-block}
.muted{color:#888}
.date-row{display:flex;gap:16px}
.date-col{flex:1}
.form-select{width:100%}
.field-label{display:block;font-size:13px;color:#4b5563;margin-bottom:6px}
.required-star{color:#d9534f;margin-left:4px}
.export-note{background:#fff0f0;border-radius:6px;padding:12px 14px;color:#a33;display:flex;align-items:center}
.required-legend{font-size:12px;color:#666}
.primary-btn{background:#052a45}
.dialog-buttons{display:flex;justify-content:center;align-items:center;gap:16px;width:100%}
.btn.cancel-btn{background:#0b2636;color:#fff;border:1px solid rgba(0,0,0,0.15)}
/* Apply button sizing and alignment inside date-picker popover */
.start-menu .v-card-actions,
.end-menu .v-card-actions {
  justify-content: flex-end !important;
  padding: 6px 10px !important;
  align-items: center;
}
.start-menu .v-card-actions .v-btn,
.end-menu .v-card-actions .v-btn {
  min-width: 72px;
  height: 34px;
  padding: 4px 12px;
  font-size: 13px;
  border-radius: 6px;
}
.start-menu .v-card-text,
.end-menu .v-card-text { padding-bottom: 6px }
.field-error{color:#d9534f;font-size:13px;margin-top:6px}
.columnMenu {
  max-width: 200px;
  top: 250px;
}

.columnMenu {
  max-width: 260px;
}

.column-card {
  width: 100%;
  max-width: 260px;
}

.column-header {
  font-weight: 600;
  font-size: 14px;
  padding: 12px 16px;
}

.column-list {
  max-height: 260px;
  overflow-y: auto;
  padding: 0 8px;
}

.column-text {
  font-size: 13px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.column-footer {
  position: sticky;
  bottom: 0;
  background: #fff;
  padding: 8px 12px;
}

.manage-btn {
  max-width: 200px;
  white-space: nowrap;
}

.rotate {
  transform: rotate(180deg);
  transition: transform 0.2s ease;
}

.v-input--selection-controls {
  margin-top: 0px !important;
  padding-top: 0px !important;
}
</style>
